import { DetailInfoRow } from '../consts';
import InfoRow from './InfoRow';
import { ReactNode } from 'react';

type Props<T> = {
  rows: DetailInfoRow<T>[];
  // Undefined while the detail query is loading, so every row falls back to a placeholder.
  entity: T | undefined;
  breakAll?: boolean;
  // Short, uniform values (e.g. the points figures) read better side by side than stacked in two columns.
  columns?: 2 | 3;
  // Rendered as a final grid cell, for actions that belong beside the fields.
  children?: ReactNode;
};

const MISSING_VALUE = '—';

function InfoGrid<T>({ rows, entity, breakAll = false, columns = 2, children }: Props<T>) {
  return (
    <div
      className={`grid grid-cols-1 gap-3 md:gap-x-8 md:gap-y-4 ${columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}
    >
      {rows.map((cellSchema) => (
        <InfoRow
          key={cellSchema.headerLabel}
          label={cellSchema.headerLabel}
          value={entity ? cellSchema.getValue(entity) : MISSING_VALUE}
          copyable={cellSchema.copyable}
          breakAll={breakAll}
          stacked
        />
      ))}
      {children}
    </div>
  );
}

export default InfoGrid;
